import type { IconProps } from "../types";

export const BookOpen = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12 7v14" />
    <path d="M2 18V3h6a4 4 0 0 1 4 4 4 4 0 0 1 4-4h6v15h-7a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
  </svg>
);
